import React from 'react';
import PropTypes from 'prop-types';
import ThemeToggle from '../auth/ThemeToggle';
import Footer from '../common/Footer';
import '../../styles/error.css';

export default function ErrorLayout({ 
  code, 
  title, 
  message, 
  icon, 
  accentColor = 'red',
  children 
}) {
  const renderIcon = () => {
    switch (icon) {
      case 'warning':
        return (
          <svg viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
          </svg>
        );
      case 'settings':
        return (
          <svg viewBox="0 0 24 24">
            <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" fill="currentColor"/>
          </svg>
        );
      case 'shield':
        return (
          <svg viewBox="0 0 24 24">
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" fill="currentColor"/>
          </svg>
        );
      case 'maintenance':
        return (
          <svg viewBox="0 0 24 24">
            <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" fill="currentColor"/>
          </svg>
        );
      default:
        return null;
    }
  };

  const getAccentClass = () => {
    switch (accentColor) {
      case 'gold':
        return 'error-card--gold';
      case 'green':
        return 'error-card--green';
      case 'blue':
        return 'error-card--blue';
      default:
        return '';
    }
  };

  return (
    <div className="error-page">
      <ThemeToggle />
      <div className="error-container">
        <div className={`error-card ${getAccentClass()}`}>
          <div className={`error-icon error-icon--${accentColor}`}>
            {renderIcon()}
          </div>
          <div className="error-code">{code}</div>
          <h1 className="error-title">{title}</h1>
          <p className="error-message">{message}</p>
          {children}
        </div>
      </div>
      <Footer variant="minimal" />
    </div>
  );
}

ErrorLayout.propTypes = {
  code: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.node.isRequired,
  icon: PropTypes.oneOf(['warning', 'settings', 'shield', 'maintenance']),
  accentColor: PropTypes.oneOf(['red', 'gold', 'green', 'blue']),
  children: PropTypes.node,
};
